module.exports = __webpack_public_path__ + "static/media/17.7559a8a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/17.png
// module id = 798
// module chunks = 0